import {
    ADD_FORM_PROPERTIES,
    ADD_FORM_DRAFT_PROPERTIES,
    ADD_FORM_COMPLETE,
    ADD_FORM_SUBMISSION_FAILED
} from '../../Actions/FormPropertyAction/FormPropertyAction';

const initialState = {
    name: "",
    version: "",
    hasDraftId: "",
    formRedirected: false,
    draftRecordId: null,
    submitForm: false
};

export default function formReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_FORM_PROPERTIES:
            return {
                ...state,
                name: action.payload.name,
                version: action.payload.version,
                orgid: action.payload.orgid,
                organisationArn: action.payload.organisationArn,
                rootFormCode: action.payload.rootFormCode,
                formCode: action.payload.formCode,
                formDataType: action.payload.formDataType,
                draftReturnUrl: action.payload.draftReturnUrl
            }

        case ADD_FORM_DRAFT_PROPERTIES:
            return {
                ...state,
                draftRecordId: action.payload
            }

        case ADD_FORM_COMPLETE:
            return {
                ...state,
                submitForm: true
            }
            
        case ADD_FORM_SUBMISSION_FAILED:
            return {
                ...state,
                submitForm: false
            }

        default:
            return state;
    }
}
